import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-scroll-to-complete',
  templateUrl: './ui-scroll-to-complete.component.html',
  styleUrls: ['./ui-scroll-to-complete.component.scss']
})
export class UiScrollToCompleteComponent implements OnInit {

  @Input() label: string;
  @Input() containerClass: string;
  @Input() onContentClicked: (event) => void;

  constructor() { }

  ngOnInit() {
  }

}
